(function () {
  'use strict';

  var incompleteScheduleText = 'Pay remaining amount on';

  function normaliseText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function repairDeferredPurchaseConsent() {
    var consent = document.querySelector('#shopify-buyer-consent[data-consent-type="subscription"]');

    if (!consent || consent.getAttribute('data-lgm-deferred-consent') === 'true') {
      return;
    }

    var policyButton = consent.querySelector('#shopify-subscription-policy-button');

    consent.textContent = 'This cart includes a preorder. By continuing, I agree to the ';

    if (policyButton) {
      policyButton.textContent = 'cancellation policy';
      consent.appendChild(policyButton);
    } else {
      var policyText = document.createTextNode('cancellation policy');
      consent.appendChild(policyText);
    }

    consent.appendChild(document.createTextNode(' and, where a balance remains, authorize its collection under the payment schedule shown above.'));
    consent.setAttribute('data-lgm-deferred-consent', 'true');
  }

  function repairDibsScheduleText() {
    var descriptions = document.querySelectorAll('.lb-ordereasy-payment-option-description');

    descriptions.forEach(function (description) {
      if (normaliseText(description.textContent) !== incompleteScheduleText) {
        return;
      }

      var option = description.closest('.lb-ordereasy-payment-option-text-content');
      var title = option ? option.querySelector('.lb-ordereasy-payment-option-title') : null;
      var amountMatch = title ? normaliseText(title.textContent).match(/^Partial payment\s*-\s*(.+)$/i) : null;
      var depositText = amountMatch ? amountMatch[1] + ' deposit today.' : 'Deposit due today.';

      description.textContent = depositText + ' Remaining balance due when your order is ready for dispatch.';
      description.setAttribute('data-lgm-dibs-schedule-fallback', 'true');
    });
  }

  function repairDibsAvailableVariantButton() {
    var productJson = document.querySelector('[id^="ProductJson-"]');
    var variantSelect = document.querySelector('select[name="id"]');
    var buttonText = document.querySelector('[id^="AddToCartText-"]');

    if (!productJson || !variantSelect || !buttonText) {
      return;
    }

    var product;

    try {
      product = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    var selectedVariant = product.variants.find(function (variant) {
      return String(variant.id) === String(variantSelect.value);
    });

    if (!selectedVariant) {
      return;
    }

    var sellingPlanAllocations = selectedVariant.selling_plan_allocations || [];
    var currentButtonText = normaliseText(buttonText.textContent).toLowerCase();
    var hasStalePreorderLabel = currentButtonText === 'preorder' || currentButtonText === 'preorder now';

    var isOutOfStock = selectedVariant.inventory_management && selectedVariant.inventory_quantity <= 0;
    var isInStock = !isOutOfStock;

    if ((isInStock || sellingPlanAllocations.length === 0) && hasStalePreorderLabel) {
      var button = buttonText.closest('button');
      var status = document.querySelector('.lgm-product-status');
      var registerInterest = document.querySelector('.lgm-register-interest');

      if (isOutOfStock) {
        var isSampleSale = status && status.getAttribute('data-sample-sale') === 'true';
        buttonText.textContent = window.theme && window.theme.strings
          ? window.theme.strings.soldOut
          : 'Sold out';
        if (button) button.disabled = true;
        if (status) {
          status.textContent = isSampleSale
            ? 'This one-off sample pair has sold'
            : 'Currently unavailable - produced and restocked in limited runs';
        }
        if (registerInterest) registerInterest.classList.toggle('hide', isSampleSale);
      } else {
        buttonText.textContent = window.theme && window.theme.strings
          ? window.theme.strings.addToCart
          : 'Add to cart';
        if (button) button.disabled = false;
      }
      buttonText.setAttribute('data-lgm-dibs-button-fallback', 'true');
    }
  }

  function repairDibsPresentation() {
    repairDibsScheduleText();
    repairDibsAvailableVariantButton();
    repairDeferredPurchaseConsent();
  }

  function initialiseDibsScheduleFallback() {
    repairDibsPresentation();

    if (!window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(repairDibsPresentation);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initialiseTaggedGalleries() {
    document.querySelectorAll('[data-lgm-tagged-gallery]').forEach(function (gallery) {
      var endpoint = gallery.getAttribute('data-feed-url');
      var grid = gallery.querySelector('[data-lgm-tagged-grid]');
      var assetTemplate = gallery.getAttribute('data-asset-template') || '';
      var modal = gallery.querySelector('[data-lgm-gallery-modal]');
      var player = gallery.querySelector('[data-lgm-gallery-player]');
      var credit = gallery.querySelector('[data-lgm-gallery-credit]');
      var activeGalleryTrigger = null;
      var currentDynamicItems = [];
      var initialRenderComplete = false;

      function assetUrl(filename) {
        return filename && assetTemplate ? assetTemplate.replace('lgm-archive-manifest.js', filename) : filename;
      }

      function youtubeFrame(id, preview) {
        var frame = document.createElement('iframe');
        var parameters = preview
          ? '?autoplay=1&mute=1&controls=0&loop=1&playlist=' + encodeURIComponent(id) + '&playsinline=1&modestbranding=1'
          : '?autoplay=1&controls=1&playsinline=1&rel=0';
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + parameters;
        frame.title = preview ? 'Muted video preview' : 'Archive video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = !preview;
        return frame;
      }

      function closeVideo() {
        if (!modal || !player) return;
        player.replaceChildren();
        if (credit) credit.textContent = '';
        modal.hidden = true;
        document.body.classList.remove('lgm-gallery-modal-open');
        if (activeGalleryTrigger) {
          activeGalleryTrigger.setAttribute('aria-expanded', 'false');
          activeGalleryTrigger.focus();
          activeGalleryTrigger = null;
        }
      }

      gallery.querySelectorAll('[data-lgm-gallery-close]').forEach(function (button) {
        button.addEventListener('click', closeVideo);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && !modal.hidden) closeVideo();
      });

      function platformMark(platform) {
        var mark = document.createElement('span');
        mark.className = 'lgm-tagged-gallery__platform lgm-tagged-gallery__platform--' + platform;
        mark.setAttribute('aria-hidden', 'true');
        mark.textContent = platform === 'instagram' ? '◎' : platform === 'x' ? 'X' : platform === 'youtube' ? '▶' : 'LGM';
        return mark;
      }

      function openMedia(item, imageUrl, mediaUrl, trigger) {
        if (!modal || !player) return;
        player.replaceChildren();
        player.className = 'lgm-gallery-modal__player';
        if (item.youtubeId) {
          player.classList.add('lgm-gallery-modal__player--video');
          player.appendChild(youtubeFrame(item.youtubeId, false));
        } else if (item.type === 'video' && mediaUrl) {
          player.classList.add('lgm-gallery-modal__player--video');
          var video = document.createElement('video');
          video.src = mediaUrl;
          video.poster = imageUrl;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          player.appendChild(video);
        } else {
          var imageClose = document.createElement('button');
          var fullImage = document.createElement('img');
          imageClose.type = 'button';
          imageClose.className = 'lgm-gallery-modal__image-close';
          imageClose.setAttribute('aria-label', 'Close enlarged image');
          fullImage.src = imageUrl;
          fullImage.alt = item.alt || '';
          imageClose.appendChild(fullImage);
          imageClose.addEventListener('click', closeVideo);
          player.appendChild(imageClose);
        }
        if (credit) {
          credit.textContent = item.credit || item.creator || '';
          if (item.permalink) {
            var sourceLink = document.createElement('a');
            sourceLink.href = item.permalink;
            sourceLink.target = '_blank';
            sourceLink.rel = 'noopener noreferrer';
            sourceLink.textContent = 'View original post';
            credit.appendChild(document.createTextNode(' - '));
            credit.appendChild(sourceLink);
          }
        }
        modal.hidden = false;
        document.body.classList.add('lgm-gallery-modal-open');
        activeGalleryTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        var imageCloseButton = player.querySelector('.lgm-gallery-modal__image-close');
        if (imageCloseButton) imageCloseButton.focus();
        else {
          player.tabIndex = -1;
          player.focus();
        }
      }

      function makeTile(item) {
        var tile = document.createElement('article');
        var openButton = document.createElement('button');
        var image = document.createElement('img');
        var overlay = document.createElement(item.permalink ? 'a' : 'span');
        var imageUrl = item.asset ? assetUrl(item.poster || item.asset) : item.image;
        var mediaUrl = item.asset ? assetUrl(item.asset) : item.video;
        tile.className = 'lgm-tagged-gallery__item' + (item.type === 'video' || item.youtubeId ? ' lgm-tagged-gallery__video' : '');
        openButton.type = 'button';
        openButton.className = 'lgm-tagged-gallery__open';
        openButton.setAttribute('aria-haspopup', 'dialog');
        openButton.setAttribute('aria-expanded', 'false');
        openButton.setAttribute('aria-label', item.alt || ('Open archive item by ' + (item.creator || 'LGM Studio')));
        var declaredWidth = parseFloat(item.width) || 1;
        var declaredHeight = parseFloat(item.height) || 1;
        openButton.style.aspectRatio = declaredWidth + ' / ' + declaredHeight;
        image.src = imageUrl;
        image.alt = item.alt || '';
        image.loading = item.priority ? 'eager' : 'lazy';
        image.decoding = 'async';
        overlay.className = 'lgm-tagged-gallery__source';
        if (item.permalink) {
          overlay.href = item.permalink;
          overlay.target = '_blank';
          overlay.rel = 'noopener noreferrer';
          overlay.setAttribute('aria-label', 'View original post by ' + (item.credit || item.creator || 'creator'));
        }
        overlay.appendChild(platformMark(item.platform || 'local'));
        overlay.appendChild(document.createTextNode(item.credit || item.creator || 'Archive'));
        openButton.appendChild(image);
        if (item.type === 'video' || item.youtubeId) {
          var play = document.createElement('span');
          play.className = 'lgm-tagged-gallery__play';
          play.setAttribute('aria-hidden', 'true');
          openButton.appendChild(play);
        }
        tile.appendChild(openButton);
        tile.appendChild(overlay);

        function sizeMasonryTile() {
          if (!image.naturalWidth || !image.naturalHeight || !grid.clientWidth) return;
          var styles = window.getComputedStyle(grid);
          var rowHeight = parseFloat(styles.gridAutoRows) || 0.5;
          var rowGap = parseFloat(styles.rowGap) || 0;
          var itemMargin = parseFloat(window.getComputedStyle(tile).marginBottom) || 0;
          var renderedHeight = openButton.getBoundingClientRect().height;
          tile.style.gridRowEnd = 'span ' + Math.ceil((renderedHeight + itemMargin + rowGap) / (rowHeight + rowGap));
        }
        image.addEventListener('load', function () {
          openButton.style.aspectRatio = image.naturalWidth + ' / ' + image.naturalHeight;
          window.requestAnimationFrame(sizeMasonryTile);
        }, { once: true });
        if (image.complete && image.naturalWidth) {
          openButton.style.aspectRatio = image.naturalWidth + ' / ' + image.naturalHeight;
          window.requestAnimationFrame(sizeMasonryTile);
        }
        window.requestAnimationFrame(sizeMasonryTile);

        var preview;
        var timer;
        if (item.youtubeId) {
          tile.addEventListener('pointerenter', function () {
            if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            timer = window.setTimeout(function () {
              if (openButton.querySelector('iframe')) return;
              preview = youtubeFrame(item.youtubeId, true);
              openButton.appendChild(preview);
            }, 180);
          });
          tile.addEventListener('pointerleave', function () {
            window.clearTimeout(timer);
            if (preview) preview.remove();
            preview = null;
          });
        }
        openButton.addEventListener('click', function () {
          window.clearTimeout(timer);
          if (preview) preview.remove();
          preview = null;
          openMedia(item, imageUrl, mediaUrl, openButton);
        });
        return tile;
      }

      function itemPostKey(item) {
        var match = String(item.permalink || '').match(/(?:instagram\.com\/(?:p|reel)\/|x\.com\/[^/]+\/status\/|youtube\.com\/watch\?v=)([^/?#]+)/i);
        return match ? match[1] : (item.permalink || item.id);
      }

      function stableRank(item, position) {
        var value = String(item.id || '') + ':' + position;
        var hash = 2166136261;
        for (var i = 0; i < value.length; i += 1) {
          hash ^= value.charCodeAt(i);
          hash = Math.imul(hash, 16777619);
        }
        return hash >>> 0;
      }

      function interleave(items) {
        var result = [];
        var remaining = items.slice();
        var columns = window.matchMedia('(min-width: 750px)').matches ? 4 : 2;
        while (remaining.length) {
          var previous = result.length ? result[result.length - 1] : null;
          var above = result.length >= columns ? result[result.length - columns] : null;
          var recentPosts = new Set(result.slice(-Math.max(8, columns * 2)).map(itemPostKey));
          var index = 0;
          var bestScore = Infinity;
          remaining.forEach(function (item, itemIndex) {
            var score = stableRank(item, result.length) / 4294967296;
            if (previous && item.creator === previous.creator) score += 10000;
            if (above && item.creator === above.creator) score += 5000;
            if (recentPosts.has(itemPostKey(item))) score += 2500;
            if (previous && item.platform === previous.platform) score += 100;
            if (score < bestScore) {
              bestScore = score;
              index = itemIndex;
            }
          });
          result.push(remaining.splice(index, 1)[0]);
        }
        return result;
      }

      function render(dynamicItems) {
        grid.classList.add('lgm-tagged-gallery__grid--loading');
        grid.classList.remove('lgm-tagged-gallery__grid--ready');
        grid.setAttribute('aria-busy', 'true');
        var curated = Array.isArray(window.LGM_ARCHIVE_ITEMS) ? window.LGM_ARCHIVE_ITEMS.slice() : [];
        var seen = new Set(curated.map(function (item) { return item.id; }));
        var seenInstagramPosts = new Set(curated.filter(function (item) {
          return item.platform === 'instagram';
        }).map(function (item) {
          var match = String(item.permalink || '').match(/instagram\.com\/(?:p|reel)\/([^/?#]+)/i);
          return match ? match[1] : '';
        }).filter(Boolean));
        (dynamicItems || []).forEach(function (item) {
          var creator = item.creator || item.username || 'lukegrantmuller';
          var postMatch = String(item.permalink || '').match(/instagram\.com\/(?:p|reel)\/([^/?#]+)/i);
          var postKey = item.shortcode || (postMatch ? postMatch[1] : '');
          if (!item.image || seen.has(item.id) || (postKey && seenInstagramPosts.has(postKey))) return;
          seen.add(item.id);
          item.platform = item.platform || 'instagram';
          item.creator = creator;
          item.credit = item.credit || ('@' + creator);
          curated.push(item);
        });
        var first = curated.filter(function (item) { return item.priority === 1; });
        var rest = curated.filter(function (item) { return item.priority !== 1; });
        grid.replaceChildren();
        first.concat(interleave(rest)).forEach(function (item) { grid.appendChild(makeTile(item)); });
        window.requestAnimationFrame(function () {
          resizeMasonry();
          window.requestAnimationFrame(function () {
            grid.classList.remove('lgm-tagged-gallery__grid--loading');
            grid.classList.add('lgm-tagged-gallery__grid--ready');
            grid.setAttribute('aria-busy', 'false');
          });
        });
      }

      function finishInitialRender(dynamicItems) {
        if (initialRenderComplete) return;
        initialRenderComplete = true;
        currentDynamicItems = Array.isArray(dynamicItems) ? dynamicItems : [];
        render(currentDynamicItems);
      }

      function resizeMasonry() {
        var styles = window.getComputedStyle(grid);
        var rowHeight = parseFloat(styles.gridAutoRows) || 0.5;
        var rowGap = parseFloat(styles.rowGap) || 0;
        grid.querySelectorAll('.lgm-tagged-gallery__item').forEach(function (tile) {
          var button = tile.querySelector('.lgm-tagged-gallery__open');
          if (!button) return;
          var itemMargin = parseFloat(window.getComputedStyle(tile).marginBottom) || 0;
          tile.style.gridRowEnd = 'span ' + Math.ceil((button.getBoundingClientRect().height + itemMargin + rowGap) / (rowHeight + rowGap));
        });
      }

      if (!grid) return;
      if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          resizeMasonry();
        }, 160);
      });
      if (!endpoint) {
        finishInitialRender([]);
        return;
      }
      var initialRenderTimer = window.setTimeout(function () {
        finishInitialRender([]);
      }, 2000);
      fetch(endpoint, { credentials: 'omit', mode: 'cors' })
        .then(function (response) {
          if (!response.ok) throw new Error('Tagged gallery unavailable');
          return response.json();
        })
        .then(function (payload) {
          window.clearTimeout(initialRenderTimer);
          finishInitialRender(Array.isArray(payload.items) ? payload.items : []);
        })
        .catch(function () {
          window.clearTimeout(initialRenderTimer);
          finishInitialRender([]);
        });
    });
  }

  function initialiseProductCardHoverMedia() {
    var mediaItems = Array.prototype.slice.call(document.querySelectorAll('[data-lgm-hover-media]'));
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;

    mediaItems.forEach(function (media) {
      var hoverImage = media.querySelector('.lgm-card-media__hover');
      if (!hoverImage) return;

      function markReady() {
        media.classList.add('lgm-card-media--ready');
      }

      if (hoverImage.complete && hoverImage.naturalWidth > 0) {
        markReady();
      } else {
        hoverImage.addEventListener('load', markReady, { once: true });
      }

      var video = media.querySelector('.lgm-card-media__video');
      var videoSource = media.getAttribute('data-lgm-card-video-src');
      var progress = media.querySelector('.lgm-card-media__loading-progress');
      var container = media.closest('.grid-view-item__image-container');
      if (!container) return;

      var canUseVideo = Boolean(video && videoSource && !reducedMotion);
      var isActive = false;
      var enteredAt = 0;
      var playTimer = null;
      var flashSwapTimer = null;
      var flashEndTimer = null;
      var sourceAttached = false;
      var videoReady = false;

      function flashTransition(swap) {
        window.clearTimeout(flashSwapTimer);
        window.clearTimeout(flashEndTimer);
        media.classList.remove('lgm-card-media--flash');
        void media.offsetWidth;
        media.classList.add('lgm-card-media--flash');

        if (typeof swap === 'function') {
          flashSwapTimer = window.setTimeout(swap, 90);
        }

        flashEndTimer = window.setTimeout(function () {
          media.classList.remove('lgm-card-media--flash');
        }, 320);
      }

      function setProgress(value) {
        if (!progress) return;
        var bounded = Math.max(0.08, Math.min(1, value || 0));
        progress.style.transform = 'scaleX(' + bounded + ')';
      }

      function updateBufferedProgress() {
        if (!video) return;
        if (!video.duration || !video.buffered.length) return;
        setProgress(video.buffered.end(video.buffered.length - 1) / video.duration);
      }

      function warmVideo() {
        if (!canUseVideo || sourceAttached) return;
        sourceAttached = true;
        video.src = videoSource;
        video.preload = 'auto';
        video.load();
      }

      function startVideo() {
        if (!canUseVideo || !isActive || !videoReady) return;
        video.currentTime = 0;
        var playResult = video.play();

        if (playResult && typeof playResult.then === 'function') {
          playResult.then(function () {
            if (isActive) {
              flashTransition(function () {
                if (isActive) media.classList.add('lgm-card-media--video-playing');
              });
            }
          }).catch(function () {
            media.classList.remove('lgm-card-media--video-playing');
          });
        } else {
          flashTransition(function () {
            if (isActive) media.classList.add('lgm-card-media--video-playing');
          });
        }
      }

      function scheduleVideo() {
        if (!canUseVideo || !isActive || !videoReady) return;
        window.clearTimeout(playTimer);
        playTimer = window.setTimeout(startVideo, Math.max(0, 1000 - (performance.now() - enteredAt)));
      }

      function markVideoReady() {
        if (videoReady) return;
        videoReady = true;
        setProgress(1);
        media.classList.add('lgm-card-media--video-ready');
        scheduleVideo();
      }

      function activate() {
        if (isActive) return;
        isActive = true;
        enteredAt = performance.now();
        media.classList.add('lgm-card-media--active');
        flashTransition();
        warmVideo();
        scheduleVideo();
      }

      function deactivate(immediate) {
        if (!isActive) return;
        isActive = false;
        window.clearTimeout(playTimer);
        if (video) {
          video.pause();
          try { video.currentTime = 0; } catch (error) {}
        }
        if (immediate) {
          window.clearTimeout(flashSwapTimer);
          window.clearTimeout(flashEndTimer);
          media.classList.remove('lgm-card-media--active', 'lgm-card-media--video-playing', 'lgm-card-media--flash');
          return;
        }
        flashTransition(function () {
          media.classList.remove('lgm-card-media--active', 'lgm-card-media--video-playing');
        });
      }

      if (canUseVideo) {
        video.addEventListener('progress', updateBufferedProgress);
        video.addEventListener('loadedmetadata', updateBufferedProgress);
        video.addEventListener('canplay', markVideoReady, { once: true });
        video.addEventListener('error', function () {
          media.classList.remove('lgm-card-media--video-ready', 'lgm-card-media--video-playing');
        });
        video.addEventListener('contextmenu', function (event) { event.preventDefault(); });
      }

      if (finePointer) {
        container.addEventListener('pointerenter', activate);
        container.addEventListener('pointerleave', deactivate);
      }

      var longPressTimer = null;
      var longPressTriggered = false;
      var touchStartX = 0;
      var touchStartY = 0;
      var activeTouchId = null;
      var longPressResetTimer = null;

      function cancelPendingLongPress() {
        window.clearTimeout(longPressTimer);
        longPressTimer = null;
      }

      function findTouch(touchList, identifier) {
        for (var index = 0; index < touchList.length; index += 1) {
          if (touchList[index].identifier === identifier) return touchList[index];
        }
        return null;
      }

      function primeTouchVideo() {
        if (!canUseVideo) return;
        warmVideo();
        var primeResult = video.play();
        if (primeResult && typeof primeResult.catch === 'function') {
          primeResult.catch(function () {});
        }
      }

      function stopPrimedVideo() {
        if (!video || isActive) return;
        video.pause();
        try { video.currentTime = 0; } catch (error) {}
      }

      container.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        var touch = event.touches[0];
        cancelPendingLongPress();
        window.clearTimeout(longPressResetTimer);
        longPressTriggered = false;
        activeTouchId = touch.identifier;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        primeTouchVideo();
        longPressTimer = window.setTimeout(function () {
          longPressTimer = null;
          longPressTriggered = true;
          activate();
        }, 360);
      }, { passive: true });

      document.addEventListener('touchmove', function (event) {
        if (activeTouchId === null) return;
        var touch = findTouch(event.touches, activeTouchId);
        if (!touch) return;
        if (Math.abs(touch.clientX - touchStartX) > 10 || Math.abs(touch.clientY - touchStartY) > 10) {
          cancelPendingLongPress();
          activeTouchId = null;
          if (longPressTriggered) deactivate(true);
          else stopPrimedVideo();
        }
      }, { passive: true });

      function endTouchPress(event) {
        if (activeTouchId === null || !findTouch(event.changedTouches, activeTouchId)) return;
        cancelPendingLongPress();
        activeTouchId = null;
        if (longPressTriggered) {
          deactivate(true);
          window.clearTimeout(longPressResetTimer);
          longPressResetTimer = window.setTimeout(function () {
            longPressTriggered = false;
          }, 700);
        } else stopPrimedVideo();
        if (event.type === 'touchcancel') longPressTriggered = false;
      }

      document.addEventListener('touchend', endTouchPress, { passive: true });
      document.addEventListener('touchcancel', endTouchPress, { passive: true });
      window.addEventListener('blur', function () {
        cancelPendingLongPress();
        activeTouchId = null;
        longPressTriggered = false;
        deactivate(true);
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          cancelPendingLongPress();
          activeTouchId = null;
          longPressTriggered = false;
          deactivate(true);
        }
      });
      container.addEventListener('contextmenu', function (event) {
        if (longPressTriggered || isActive) event.preventDefault();
      });
      container.addEventListener('click', function (event) {
        if (!longPressTriggered) return;
        event.preventDefault();
        event.stopPropagation();
        window.clearTimeout(longPressResetTimer);
        longPressTriggered = false;
      });

      media.lgmWarmVideo = warmVideo;
    });

    if (!finePointer || reducedMotion || saveData) return;

    function warmHomepageVideos() {
      var ordered = mediaItems.slice().sort(function (a, b) {
        var aVisible = a.getBoundingClientRect().top < window.innerHeight ? 0 : 1;
        var bVisible = b.getBoundingClientRect().top < window.innerHeight ? 0 : 1;
        return aVisible - bVisible;
      });

      ordered.forEach(function (media, index) {
        window.setTimeout(function () {
          if (typeof media.lgmWarmVideo === 'function') media.lgmWarmVideo();
        }, index * 350);
      });
    }

    function scheduleWarmup() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmHomepageVideos, { timeout: 1600 });
      } else {
        window.setTimeout(warmHomepageVideos, 600);
      }
    }

    if (document.readyState === 'complete') scheduleWarmup();
    else window.addEventListener('load', scheduleWarmup, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseDibsScheduleFallback);
    document.addEventListener('DOMContentLoaded', initialiseTaggedGalleries);
    document.addEventListener('DOMContentLoaded', initialiseProductCardHoverMedia);
  } else {
    initialiseDibsScheduleFallback();
    initialiseTaggedGalleries();
    initialiseProductCardHoverMedia();
  }
})();
